import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { Ed } from "../Editorial";
import { fmtRange } from "../../lib/time";

// El recibo de una compra. Puede traer una clase o doce: el carrito manda una
// lista, y una reserva suelta llega como una lista de uno.
export const ReceiptModal = ({ receipt, onAgain }) => {
  const { lang, t } = useLang();
  const r = t.receipt;
  const reservas = receipt.bookings || [receipt];
  const varias = reservas.length > 1;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm px-4" data-testid="receipt-modal">
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-lg bg-[#0C0C0C] border border-[#C5A059]/40 p-10 max-h-[90vh] overflow-y-auto"
      >
        <div className="w-14 h-14 rounded-full border border-[#C5A059] flex items-center justify-center mx-auto">
          <Check className="text-[#C5A059]" size={26} />
        </div>
        <h2 className="mt-8 font-serif text-3xl md:text-4xl text-white text-center">
          <Ed text={varias ? r.confirmedMany.replace("{n}", reservas.length) : r.confirmed} />
        </h2>

        <div className="mt-10 divide-y divide-white/5 border-y border-white/5" data-testid="receipt-classes">
          {reservas.map((bk) => (
            <div key={bk.receipt_number} className="py-4">
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <p className="font-serif italic text-lg text-[#C5A059]">{bk.class_name[lang]}</p>
                  <p className="mt-1 text-xs text-zinc-500 font-light">
                    {bk.class_date} · {fmtRange(bk.class_time, bk.class_time_end)}
                  </p>
                  <p className="mt-1 text-[0.65rem] uppercase tracking-[0.2em] text-zinc-600">
                    {bk.instructor} ·{" "}
                    {bk.kind === "floor"
                      ? `${bk.bikes.length} ${bk.bikes.length === 1 ? t.booking.spotLabel : t.booking.spotsLabel}`
                      : `${r.bikes} ${bk.bikes.join(", ")}`}
                  </p>
                  <p className="mt-1 text-[0.6rem] uppercase tracking-[0.2em] text-zinc-700">{bk.receipt_number}</p>
                </div>
                <span className="text-sm text-white shrink-0">${Number(bk.total).toFixed(2)}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-between pt-5">
          <span className="text-zinc-400">{r.total}</span>
          <span className="font-serif text-2xl text-[#C5A059]" data-testid="receipt-total">
            ${Number(receipt.total).toFixed(2)}
          </span>
        </div>

        {receipt.reward_earned && (
          <p data-testid="receipt-reward" className="mt-8 text-center text-sm text-[#C5A059] border border-[#C5A059]/40 bg-[#C5A059]/5 rounded-sm py-3 px-4">
            {r.rewardEarned}
          </p>
        )}

        {/* Solo se promete el recibo si de verdad salió un correo. */}
        {receipt.email_sent && (
          <p className="mt-8 text-xs text-zinc-500 text-center font-light">
            {r.emailNote} <span className="text-zinc-300">{receipt.email}</span>
          </p>
        )}

        <p className="mt-4 text-[0.7rem] text-zinc-600 text-center leading-relaxed">{r.changeNote}</p>

        <div className="mt-8 flex flex-col gap-3">
          <button data-testid="receipt-again-btn" onClick={onAgain} className="btn-gold w-full text-center">
            {r.again}
          </button>
          <Link
            data-testid="receipt-home-link"
            to="/"
            className="text-center text-[0.65rem] uppercase tracking-[0.3em] text-zinc-500 hover:text-white transition-colors duration-300 py-2"
          >
            {r.home}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};
